import { StatisticsAreaGranularityEnum } from '@model/enum/statistics-granularity.enum';
import { useCpmsBoGetRevenueByChargePointQuery } from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import {
  MoreLessCard,
  MoreLessCardVariantEnum,
} from '../../components/more-less-card/more-less.card';
import { useFilters } from '../../context/filters.context';

export const MoreLessRevenueChargePointCard = (): React.JSX.Element | null => {
  const {
    transformedFilters,
    filters: { areaGranularity },
  } = useFilters();

  const { data } = useCpmsBoGetRevenueByChargePointQuery({
    ...transformedFilters,
  });

  return areaGranularity !== StatisticsAreaGranularityEnum.ChargePoint ? (
    <MoreLessCard data={data} variant={MoreLessCardVariantEnum.Revenue} />
  ) : null;
};
